import { Box, Modal, Typography } from "@mui/material";
import Input from "../Common/Input";
import Button from "../Common/Button";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import Select from "../Common/Select";
import {
  addOrgQuizQuestion,
  addQuizQuestion,
  updateOrgQuizQuestion,
  updateQuizQuestion,
} from "../../store/course/course.action";
import { closeDialogue } from "../../util/Dialogue";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: "13px",
  border: "1px solid #C9C9C9",
  boxShadow: 24,
  p: "19px",
};

const CreateQuizQuestion = ({ courseId, lessonId, quiz }) => {
  const dispatch = useDispatch();
  const { tokenData } = useSelector((state) => state.loggedUser);
  const { dialogue } = useSelector((state) => state.dialogue);

  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [marks, setMarks] = useState("");

  const [errors, setError] = useState({
    question: "",
    options: "",
    correctAnswer: "",
    marks: "",
  });

  const closePopup = () => {
    closeDialogue(dispatch);
  };

  const handleOptionChange = (index, value) => {
    setOptions((prev) => {
      const newOptions = [...prev];
      newOptions[index] = value;
      return newOptions;
    });
  };

  const handleSubmit = () => {
    if (!question || !correctAnswer || !marks || options.some((opt) => !opt)) {
      let error = {};
      if (!question) error.question = "Question is required!";
      if (options.some((opt) => !opt))
        error.options = "All options are required!";
      if (!correctAnswer)
        error.correctAnswer = "Correct answer must be selected!";
      if (!marks) error.marks = "Marks are required!";
      return setError({ ...error });
    } else {
      const payload = {
        questionText: question,
        options,
        correctOptionIndex: charactorToIndex(correctAnswer),
        marks: Number(marks),
      };

      // Dispatch action to add quiz question to lesson
      if (quiz) {
        const updatedQuiz = {
          ...quiz,
          questions: [...quiz.questions, payload],
        };

        if (tokenData.isOrg) {
          dispatch(updateOrgQuizQuestion(courseId, lessonId, updatedQuiz));
        } else {
          dispatch(updateQuizQuestion(courseId, lessonId, updatedQuiz));
        }
      } else {
        if (tokenData.isOrg) {
          dispatch(addOrgQuizQuestion(courseId, lessonId, payload));
        } else {
          dispatch(addQuizQuestion(courseId, lessonId, payload));
        }
      }

      closePopup();
    }
  };

  return (
    <Modal
      open={dialogue}
      onClose={closePopup}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className="create-channel-model">
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Create Quiz Question
        </Typography>
        <form>
          <div className="row gap-3">
            {/* Question Input */}
            <div className="col-12">
              <Input
                label={"Question"}
                name={"question"}
                type={"text"}
                placeholder={"Enter your question..."}
                errorMessage={errors.question && errors.question}
                value={question}
                onChange={(e) => {
                  setQuestion(e.target.value);

                  if (!e.target.value) {
                    return setError({
                      ...errors,
                      question: "Question can't be blank!",
                    });
                  } else {
                    return setError({
                      ...errors,
                      question: "",
                    });
                  }
                }}
              />
            </div>

            {/* Options Inputs */}
            <div className="col-12">
              {["a", "b", "c", "d"].map((key, index) => (
                <div
                  key={key}
                  className="d-flex align-items-center gap-2 mb-2 ps-2"
                >
                  <label>{key}</label>
                  <div className="flex-grow-1">
                    <Input
                      name={`option${key}`}
                      type={"text"}
                      placeholder={`Option ${key}...`}
                      errorMessage={
                        errors.options &&
                        !options[index] &&
                        `Option ${key} is required!`
                      }
                      value={options[index]}
                      onChange={(e) => {
                        handleOptionChange(index, e.target.value);
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Correct Answer Dropdown and Marks */}
            <div className="col-12 d-flex gap-3">
              <div className="flex-grow-1">
                <Select
                  label={"Correct Option"}
                  placeholder="Select correct option"
                  options={[
                    { label: "a", value: "a" },
                    { label: "b", value: "b" },
                    { label: "c", value: "c" },
                    { label: "d", value: "d" },
                  ]}
                  value={correctAnswer}
                  onValueChange={(value) => {
                    setCorrectAnswer(value);
                    if (!value) {
                      return setError({
                        ...errors,
                        correctAnswer: "Please select correct answer!",
                      });
                    } else {
                      return setError({
                        ...errors,
                        correctAnswer: "",
                      });
                    }
                  }}
                  errorMessage={errors.correctAnswer}
                />
              </div>

              <div style={{ width: "150px" }}>
                <Input
                  label={"Marks"}
                  name={"marks"}
                  type={"number"}
                  placeholder={"Marks"}
                  errorMessage={errors.marks && errors.marks}
                  value={marks}
                  onChange={(e) => {
                    setMarks(e.target.value);

                    if (!e.target.value) {
                      return setError({
                        ...errors,
                        marks: "Marks required!",
                      });
                    } else {
                      return setError({
                        ...errors,
                        marks: "",
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex justify-content-end gap-2">
            <Button type={"button"} className={"close"} onClick={closePopup}>
              Cancel
            </Button>
            <Button type={"button"} onClick={handleSubmit} className={"submit"}>
              Submit
            </Button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

// charactor to index
const charactorToIndex = (charactor) => {
  return charactor.charCodeAt(0) - "a".charCodeAt(0);
};

export default CreateQuizQuestion;
